import {FC} from 'react';
import {CouponsView} from '../components';
import {ThemeProvider} from "@mui/material";
import {adminTheme} from "../../../themes";

export const CouponsPage: FC = () => {
    return (
        <ThemeProvider theme={adminTheme}>
            <CouponsView/>
        </ThemeProvider>
    );
};
